import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollHeader(threshold = 10) {
  const [isScrolled, setIsScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    const cleanup: { raf2?: number } = {};

    handleScroll();
    const raf1 = window.requestAnimationFrame(() => {
      handleScroll();
      cleanup.raf2 = window.requestAnimationFrame(handleScroll);
    });
    const timeout = window.setTimeout(handleScroll, 120);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.cancelAnimationFrame(raf1);
      if (cleanup.raf2) window.cancelAnimationFrame(cleanup.raf2);
      window.clearTimeout(timeout);
    };
  }, [threshold, pathname]);

  return isScrolled;
}
